import { useTranslation } from 'react-i18next';
import { SidebarLayoutHeader } from '~/layout/components/sidebar-layout-header/SidebarLayoutHeader';
import { StandardHeader } from '~/layout/components/standard-header/StandardHeader';

export interface WorkoutsHeaderProps {}

export interface WorkoutsHeaderBodyProps {
  className?: string;
}

const WorkoutsHeaderBody = ({ className }: WorkoutsHeaderBodyProps) => {
  const { t } = useTranslation('workout');

  return (
    <StandardHeader
      className={className}
      subtitle={t('subtitle')}
      title={t('title')}
    />
  );
};

export const WorkoutsHeader = Object.assign(
  ({}: WorkoutsHeaderProps) => {
    return (
      <SidebarLayoutHeader>
        <WorkoutsHeaderBody />
      </SidebarLayoutHeader>
    );
  },
  { Body: WorkoutsHeaderBody },
);
